import { useState } from "react";
import { ListOrder } from "../components/order/ListOrder";
import { OrderDetail } from "../components/order/OrderDetail";

export const Order = () => {
  const [mode, setMode] = useState<"list" | "detail">("list");
  const [selectedId, setSelectedId] = useState<string | null>(null);

  if (mode === "detail" && selectedId) {
    return (
      <OrderDetail
        selectedId={selectedId}
        onBack={() => {
          setSelectedId(null);
          setMode("list");
        }}
      />
    );
  }

  return (
    <ListOrder
      onDetail={(id: string) => {
        setSelectedId(id);
        setMode("detail");
      }}
    />
  );
};
